var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsxs, jsx } from "react/jsx-runtime";
import { Component } from "react";
import PropTypes from "prop-types";
import { line } from "d3-shape";
import Circle from "./Circle.esm.js";
import Line from "./Line.esm.js";
class DataSeries extends Component {
  render() {
    const {
      xAccessor,
      yAccessor,
      xScale,
      yScale,
      data,
      fill,
      strokeWidth,
      seriesName,
      hoverIndex
    } = this.props;
    const interpolatePath = line().x((d) => xScale(xAccessor(d))).y((d) => yScale(yAccessor(d)));
    return /* @__PURE__ */ jsxs("g", { children: [
      /* @__PURE__ */ jsx(Line, { path: interpolatePath(data), stroke: fill, strokeWidth, id: seriesName }),
      hoverIndex && /* @__PURE__ */ jsx(Circle, { cx: xScale(xAccessor(data[hoverIndex])), cy: yScale(yAccessor(data[hoverIndex])), r: 5, fill }),
      this.props.children
    ] });
  }
}
__publicField(DataSeries, "propTypes", {
  data: PropTypes.array,
  displayDataPoints: PropTypes.bool,
  fill: PropTypes.string,
  xAccessor: PropTypes.func,
  yAccessor: PropTypes.func,
  children: PropTypes.node,
  xScale: PropTypes.func,
  yScale: PropTypes.func,
  strokeWidth: PropTypes.number,
  seriesName: PropTypes.string,
  hoverIndex: PropTypes.number
});
__publicField(DataSeries, "defaultProps", {
  data: [],
  fill: "white",
  xAccessor: (d) => d.x,
  yAccessor: (d) => d.y,
  displayDataPoints: true
});
export {
  DataSeries as default
};
